import { kartoyImages } from '@mobile/assets/kartoy'
import { WithdrawBankId } from '@shared-core/features/backend'
import type { ImageSourcePropType } from 'react-native'

export { WithdrawBankId } from '@shared-core/features/backend'

export type WithdrawBank = {
  id: WithdrawBankId
  name: string
  image: ImageSourcePropType
}

export const WITHDRAW_BANKS: WithdrawBank[] = [
  { id: WithdrawBankId.Sber, name: 'Сбер', image: kartoyImages.sber },
  { id: WithdrawBankId.Tbank, name: 'Т-Банк', image: kartoyImages.tBank },
  { id: WithdrawBankId.Alfa, name: 'Альфа-Банк', image: kartoyImages.alfa },
  { id: WithdrawBankId.Vtb, name: 'ВТБ', image: kartoyImages.vtb },
  { id: WithdrawBankId.Yandex, name: 'Яндекс', image: kartoyImages.yandex },
]

export const ALL_WITHDRAW_BANKS: WithdrawBank[] = [
  ...WITHDRAW_BANKS,
  { id: WithdrawBankId.Domrf, name: 'ДОМ.РФ', image: kartoyImages.domrf },
  { id: WithdrawBankId.Gazprom, name: 'Газпромбанк', image: kartoyImages.gazprom },
  { id: WithdrawBankId.Mts, name: 'МТС Банк', image: kartoyImages.mts },
  { id: WithdrawBankId.Ozon, name: 'Ozon Банк', image: kartoyImages.ozon },
  { id: WithdrawBankId.Post, name: 'Почта Банк', image: kartoyImages.post },
  { id: WithdrawBankId.Raiffeisen, name: 'Райффайзенбанк', image: kartoyImages.raiffeisen },
  { id: WithdrawBankId.Rocket, name: 'Рокетбанк', image: kartoyImages.rocket },
  { id: WithdrawBankId.Rshb, name: 'Россельхозбанк', image: kartoyImages.rshb },
  { id: WithdrawBankId.Sovcom, name: 'Совкомбанк', image: kartoyImages.sovcom },
  { id: WithdrawBankId.Spb, name: 'Банк Санкт-Петербург', image: kartoyImages.spb },
  { id: WithdrawBankId.Wb, name: 'Wildberries Банк', image: kartoyImages.wb },
  { id: WithdrawBankId.KgBakai, name: 'Бакай Банк', image: kartoyImages.kgBakai },
  { id: WithdrawBankId.KgDemir, name: 'ДемирБанк', image: kartoyImages.kgDemir },
  { id: WithdrawBankId.KgKicb, name: 'KICB', image: kartoyImages.kgKicb },
  { id: WithdrawBankId.KgMbank, name: 'MBANK', image: kartoyImages.kgMbank },
  { id: WithdrawBankId.KgOptima, name: 'Оптима Банк', image: kartoyImages.kgOptima },
]

export function getWithdrawBank(id: WithdrawBankId): WithdrawBank {
  return ALL_WITHDRAW_BANKS.find((bank) => bank.id === id) ?? WITHDRAW_BANKS[1]
}
